import moment from 'moment'
import React from 'react'
import { instrumentIcon } from '../../../assets/assets'

const ExpiredInstrumentsListItem = props => {
  const { expiredInstrument } = props

  return (
    <div className='expired-instrument'>
      <div className='expired-instrument-icon'>{instrumentIcon()}</div>
      <div className='expired-instrument-content'>
        <div className='expired-instrument-status'>
          {`Expired on ${expiredInstrument?.metadata?.schedule?.expire?.supText}`}
        </div>
        <div className='expired-instrument-title'>
          {expiredInstrument.instrument_title}
        </div>
      </div>
    </div>
  )
}

export default ExpiredInstrumentsListItem
